function AdminStaffController($scope, $state) { }
AdminStaffController.$inject = ["$scope", "$state"];
export default AdminStaffController;
